/* PerfumeGoal Noir — vanilla JS, no dependencies. */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const T = window.theme || {};
  const SECTION = 'cart-drawer';

  const money = (cents) => {
    const v = (cents / 100).toFixed(2);
    const [i, d] = v.split('.');
    const comma = i.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (T.money || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) =>
      k === 'amount_no_decimals' ? comma.replace(/\.\d+$/, '')
        : k.includes('comma_separator') ? `${i.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${d}`
        : `${comma}.${d}`);
  };

  /* Drawers */
  let lastFocus;
  const open = (el) => {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
    const f = $('input:not([type=hidden]), button, a[href]', $('.drawer__panel', el));
    if (f) setTimeout(() => f.focus({ preventScroll: true }), 60);
  };
  const close = (el) => {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.documentElement.classList.remove('no-scroll');
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  };

  /* Cart */
  async function refresh(sections) {
    if (sections && sections[SECTION]) {
      const doc = new DOMParser().parseFromString(sections[SECTION], 'text/html');
      const next = $('[data-cart-content]', doc);
      const cur = $('[data-cart-content]');
      if (next && cur) cur.innerHTML = next.innerHTML;
    }
    const cart = await fetch(`${T.routes.cart}.js`).then((r) => r.json());
    $$('[data-cart-count]').forEach((el) => (el.textContent = cart.item_count));
  }

  async function addToCart(form) {
    const btn = $('[data-add-button]', form);
    const err = $('[data-error]', form);
    btn.classList.add('is-loading');
    if (err) err.hidden = true;
    const body = new FormData(form);
    body.append('sections', SECTION);
    try {
      const res = await fetch(`${T.routes.add}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart.');
      await refresh(data.sections);
      open($('#CartDrawer'));
    } catch (e) {
      if (err) { err.textContent = e.message; err.hidden = false; } else alert(e.message);
    } finally {
      btn.classList.remove('is-loading');
    }
  }

  async function changeLine(line, quantity) {
    const drawer = $('#CartDrawer');
    drawer.classList.add('is-loading');
    try {
      const res = await fetch(`${T.routes.change}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: +line, quantity: Math.max(0, +quantity), sections: SECTION })
      });
      await refresh((await res.json()).sections);
    } catch {
      location.href = T.routes.cart;
    } finally {
      drawer.classList.remove('is-loading');
    }
  }

  /* Delegated clicks */
  document.addEventListener('click', (e) => {
    const t = e.target;
    const opener = t.closest('[data-open]');
    if (opener && document.getElementById(opener.dataset.open)) {
      e.preventDefault();
      return open(document.getElementById(opener.dataset.open));
    }
    if (t.closest('[data-close]')) return close(t.closest('.drawer'));

    const line = t.closest('[data-line]');
    if (line) return changeLine(line.dataset.line, line.dataset.qty);

    const step = t.closest('[data-step]');
    if (step) {
      const input = $('input', step.closest('.qty'));
      input.value = Math.max(+input.min || 0, (+input.value || 0) + +step.dataset.step);
      return input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Size pills on product cards
    const pill = t.closest('[data-pill]');
    if (pill) {
      const card = pill.closest('.card');
      $$('[data-pill]', card).forEach((p) => p.classList.toggle('is-active', p === pill));
      $('[data-card-id]', card).value = pill.dataset.id;
      $('[data-card-price]', card).textContent = pill.dataset.price;
      $('[data-card-compare]', card).textContent = pill.dataset.compare;
      const ok = pill.dataset.available === 'true';
      const btn = $('[data-add-button]', card);
      btn.disabled = !ok;
      $('[data-add-label]', btn).textContent = ok ? 'Add to Cart' : 'Sold out';
      return;
    }

    // Carousels
    const nav = t.closest('[data-carousel-prev], [data-carousel-next]');
    if (nav) {
      const track = $('[data-track]', nav.closest('[data-carousel]'));
      const dir = nav.hasAttribute('data-carousel-next') ? 1 : -1;
      const end = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (dir > 0 && end) track.scrollTo({ left: 0 });
      else track.scrollBy({ left: dir * track.clientWidth * 0.85 });
      return;
    }

    // Tabs
    const tab = t.closest('[data-tab]');
    if (tab) {
      const root = tab.closest('[data-tabs]');
      $$('[data-tab]', root).forEach((b) => {
        const on = b === tab;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on);
        document.getElementById(b.getAttribute('aria-controls')).hidden = !on;
      });
      return;
    }

    // Product gallery thumbnails
    const thumb = t.closest('[data-thumb]');
    if (thumb) return showMedia(thumb.closest('[data-product]'), thumb.dataset.thumb);

    if (t.closest('[data-filters-toggle]')) $('#Filters')?.classList.toggle('is-open');
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(close);
    $('#Filters')?.classList.remove('is-open');
  });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-add-form]');
    if (!form || T.cartType === 'page') return;
    e.preventDefault();
    addToCart(form);
  });

  /* Auto-submit: sort select, filters, cart page quantities */
  let timer;
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t.matches('[data-autosubmit]') || t.closest('[data-filter-form]')) {
      clearTimeout(timer);
      timer = setTimeout(() => t.form.requestSubmit(), t.type === 'number' ? 600 : 0);
    }
  });

  /* Product page */
  function showMedia(root, id) {
    $$('[data-media]', root).forEach((m) => m.classList.toggle('is-active', m.dataset.media === String(id)));
    $$('[data-thumb]', root).forEach((m) => m.classList.toggle('is-active', m.dataset.thumb === String(id)));
  }

  $$('[data-product]').forEach((root) => {
    const json = $('[data-variants]', root);
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    root.addEventListener('change', (e) => {
      if (!e.target.closest('[data-option]')) return;
      const chosen = $$('[data-option]', root).map((fs) => {
        const v = $('input:checked', fs)?.value;
        $('[data-option-value]', fs).textContent = v || '';
        return v;
      });
      const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]));
      const btn = $('[data-add-button]', root);
      const label = $('[data-add-label]', root);
      if (!v) { btn.disabled = true; label.textContent = 'Unavailable'; return; }
      $('[data-variant-id]', root).value = v.id;
      $('[data-price]', root).textContent = money(v.price);
      $('[data-compare]', root).textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
      btn.disabled = !v.available;
      label.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (v.featured_media) showMedia(root, v.featured_media.id);
      history.replaceState(null, '', `${location.pathname}?variant=${v.id}`);
    });
  });

  /* Hero autoplay: only while visible, paused on hover */
  $$('[data-carousel][data-autoplay="true"]').forEach((c) => {
    const next = $('[data-carousel-next]', c);
    if (!next || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let id;
    const start = () => { stop(); id = setInterval(() => next.click(), 6000); };
    const stop = () => clearInterval(id);
    new IntersectionObserver(([en]) => (en.isIntersecting ? start() : stop())).observe(c);
    c.addEventListener('mouseenter', stop);
    c.addEventListener('mouseleave', start);
  });

  /* Theme editor: reopen the cart drawer when selected */
  document.addEventListener('shopify:section:select', (e) => { if ($('#CartDrawer', e.target)) open($('#CartDrawer')); });
  document.addEventListener('shopify:section:deselect', (e) => { if ($('#CartDrawer', e.target)) close($('#CartDrawer')); });
})();
